import { Injectable } from '@angular/core';
import {BehaviorSubject, tap} from "rxjs";
import {IDepartment, IDepartmentRequest, IListDepartmentsRequest} from "../models/departement";
import {DepartementService} from "./departement.service";

@Injectable({
  providedIn: 'root'
})
export class DepartementStoreService {

  constructor(
    private departementService : DepartementService
  ) {
    this.listDepartements();
  }

  private _departements$ = new BehaviorSubject<IDepartment[]>([]);
  public departements$ = this._departements$.asObservable();

  listRequest : IListDepartmentsRequest = {
    pageNumber: 0,
    pageSize: 10
  }

  listDepartements(request = this.listRequest){
    this.departementService.listDepartements(request).subscribe(response => {
      this._departements$.next(response.data)
    })
  }

  // Returned so the caller can react to success (e.g. close the grid row); the list is refreshed either way.
  addDepartement(request: IDepartmentRequest){
    return this.departementService.addDepartement(request)
      .pipe(tap(() => this.listDepartements()));
  }

  updateDepartement(request: IDepartmentRequest){
    return this.departementService.updateDepartement(request)
      .pipe(tap(() => this.listDepartements()));
  }

  deleteDepartement(id:string){
    this.departementService.deleteDepartement(id)
      .subscribe(response => {
        this.listDepartements();
      })
  }
}
